/**
 * This component encapsulates the filter functionality for notes
 *
 * */
import {mapActions, mapMutations, mapState} from 'vuex'
import notesActions from '#/notes/store/actionTypes'
import notesMutations from '#/notes/store/mutationTypes'
import {isNil, keyBy, pick} from 'lodash'
import {componentValueGetterFunction} from '#/notes/components/definitions'

export default {
  name: 'NotesFilter',
  computed: {
    ...mapState('notes', [
      'userFilters',
      'userFiltersMetadata'
    ])
  },
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    customFilterForm: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    'userFilters': {
      handler (value) {
        if (this.formItems.length) {
          this.createUserFiltersMetadata()
        }
        this.$emit('filters-updated', value)
      }
    }
  },
  methods: {
    ...mapActions({
      updateUserFilters: notesActions.UPDATE_USER_FILTERS
    }),
    ...mapMutations({
      resetUserFilters: notesMutations.RESET_USER_FILTERS,
      removeUserFilters: notesMutations.REMOVE_USER_FILTERS,
      setUserFiltersMetadata: notesMutations.SET_USER_FILTERS_METADATA
    }),
    createUserFiltersMetadata () {
      const getFormItemData = ({label, prop}) => ({label, name: prop})
      const getComponentValue = component => {
        const type = component.$options.name
        return componentValueGetterFunction[type](component)
      }
      const maybeShowWarnings = (name, item) => {
        if (!name) console.error('ElFormItem\'s "prop" prop is required')
        if (!item.$children.length) console.warn('Empty form item')
        if (item.$children.length > 1) console.warn('Form item with multiple children is not supported')
      }

      const extractData = item => {
        const {label, name} = getFormItemData(item)
        const value = getComponentValue(item.$children[0])
        maybeShowWarnings(name, item)

        return ({
          name,
          value,
          label
        })
      }
      const hasValue = ({value}) => !isNil(value)

      const filtersMetadata = this.formItems.map(extractData).filter(hasValue)
      const filtersMetadataNameMap = keyBy(filtersMetadata, 'name')
      const userFilterKeys = Object.keys(this.userFilters)
      const userFiltersMetadata = pick(filtersMetadataNameMap, userFilterKeys)

      this.setUserFiltersMetadata(userFiltersMetadata)
    },
    filter (filters) {
      this.updateUserFilters(filters)
    },
    clear () {
      this.resetUserFilters()
    },
    remove (filter) {
      this.removeUserFilters(filter)
    }
  },
  render () {
    return this.$scopedSlots.default({
      filter: this.filter,
      clear: this.clear,
      remove: this.remove,
      metadata: this.userFiltersMetadata
    })
  }
}
